import React from "react";
import "./About.css";

function About() {
  return (
    <section id="about" className="about">
      <h2>About Me</h2>
      <p>
        I'm a passionate graduate from <strong>NIT Durgapur</strong> with a degree in <strong>Chemical Engineering</strong>. 
        <br /><br />
        Beyond academics, my heart lies in the tech world — web development, competitive programming, and content creation.
        <br /><br />
        I’ve built projects using <strong>Ethereum Blockchain</strong> and the <strong>MERN Stack</strong>, showcasing both frontend and backend expertise.
        <br /><br />
        Currently, I'm focused on sharpening my skills in <strong>Data Structures and Algorithms</strong> while also diving into <strong>Python</strong> and <strong>Machine Learning/AI</strong> for future contributions.
        <br /><br />
        Outside tech, I enjoy writing — and some of my pieces have even been featured in published anthologies.
      </p>
    </section>
  );
}

export default About;
